import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-maestro-planes',
  templateUrl: './maestro-planes.component.html',
  styleUrls: ['./maestro-planes.component.css']
})
export class MaestroPlanesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
